import JSEncrypt from 'jsencrypt'; //加密
import OSS from 'ali-oss'; //oss直传
import Mint from 'mint-ui'; //引入mint-ui
import * as imageConversion from 'image-conversion'; //引入图片处理插件
import axios from 'axios';
import { Message } from 'element-ui'

// 根据数组某一元素的uid删除本元素
export function deleteUidItem(item, fileList) {
  for (var key in fileList) {
    if (fileList[key].uid === item) {
      fileList.splice(key, 1);
    }
  }
}

// 導出excel
export function exportExcel(url, method, data, name) {
  // resolve(res.data)
  axios({
    method: method,
    headers: { 'Content-Type': 'application/json;charset=UTF-8' },
    url: url,
    responseType: 'arraybuffer',
    data: data,
  }).then(res => {
    if (res.code === "20009") {
      _this.dialogVisible = true;
      _this.$propMessage(res.message, "error", function () {
        _this.dialogVisible = false;
      });
    } else {
      let link = document.createElement('a'); // 创建隐藏的可下载链接
      link.download = `${name}.xlsx`;
      link.style.display = 'none';
      let blob = new Blob([res.data], { type: 'application/vnd.ms-excel' });  // 字符内容转变成blob地址
      link.href = URL.createObjectURL(blob);
      document.body.appendChild(link);
      link.click(); // 触发点击
      document.body.removeChild(link);   // 然后移除
    }

  }).catch(err => {
    console.log(err)
  })
}

// 登录加密
export function RsaCode(passData) {
  // new一个对象
  let encrypt = new JSEncrypt();
  // 与后台约定的公钥
  encrypt.setPublicKey('MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQCRXT6rDXIRg2EwC+99EYLpkzQRkLReiqnsdHX/PkV22+/Biuf1M/YHlR3yZ3H2TByz6LecZ2I9cJ/b6fBgoljwViCCpHsQ+6tKrJiIs6AbsEDvSlit/K7/VUOpYCcbU6m1q5aGDTZW3EfhPLgfW7Pmptu0d/0DQYKQOm9Ccn+coQIDAQAB');
  // passData是要加密的数据
  let data = encrypt.encrypt(passData);
  return data;
}

//时间戳转换
export function getTime(data, type) {
  if (data === null) {
    return '';
  } else {
    var date = new Date(data);
    var Y = date.getFullYear() + '-';
    var M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
    var D = (date.getDate() < 10 ? '0' + date.getDate() : date.getDate()) + ' ';
    var h = (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':';
    var m = (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()) + ':';
    var s = (date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds());
    return Y + M + D + h + m + s;
  }
}

// 标准时间转为字符串时间
export function formatDate(date) {
  var y = date.getFullYear();
  var m = date.getMonth() + 1;
  m = m < 10 ? ('0' + m) : m;
  var d = date.getDate();
  d = d < 10 ? ('0' + d) : d;
  var h = date.getHours();
  h = h < 10 ? ('0' + h) : h;
  var minute = date.getMinutes();
  minute = minute < 10 ? ('0' + minute) : minute;
  var second = date.getSeconds();
  second = second < 10 ? ('0' + second) : second;
  return y + '-' + m + '-' + d + ' ' + h + ':' + minute + ':' + second;
}

// 比较两个时间的大小
export function compareTime(d1, d2) {
  let date1 = new Date(Date.parse(d1));
  let date2 = new Date(Date.parse(d2));
  return date1 > date2;
}

export function getDay(day) {
  var today = new Date();

  var targetday_milliseconds = today.getTime() + 1000 * 60 * 60 * 24 * day;

  today.setTime(targetday_milliseconds); //注意，这行是关键代码

  var tYear = today.getFullYear();
  var tMonth = today.getMonth();
  var tDate = today.getDate();
  tMonth = doHandleMonth(tMonth + 1);
  tDate = doHandleMonth(tDate);
  return tYear + "-" + tMonth + "-" + tDate;
}

function doHandleMonth(month) {
  var m = month;
  if (month.toString().length == 1) {
    m = "0" + month;
  }
  return m;
}

// 校验文件格式是否为excel
export function checkData(file) {
  var suffix = file.substr(file.lastIndexOf('.'));
  if ((suffix !== '.xls') && (suffix !== '.xlsx')) {
    return false;
  }
  return true;
}

// 判断非法字符
export function getCaption(obj) {
  var index = obj.indexOf('<');
  var index2 = obj.indexOf('/');
  var index3 = obj.indexOf('>');
  var positions = new Array();
  var caption = ''
  while (index > -1) {
    positions.push(index);
    index = obj.indexOf('<', index + 1)
  }
  // while (index2 > -1) {
  //   positions.push(index2);
  //   index2 = obj.indexOf('/', index2 + 1)
  // }
  while (index3 > -1) {
    positions.push(index3);
    index3 = obj.indexOf('>', index3 + 1)
  }
  positions.forEach(v => {
    var letter = /[a-z]/i
    var frontobj = obj.substring(v - 1, v)
    var backobj = obj.substring(v + 1, v + 2)
    if (letter.test(frontobj) || letter.test(backobj)) {
      caption = true
      return false
    }
  })
  return caption
}

// oss直传生成check码
export function createOssClient() {
  let _this = this
  return new Promise((resolve, reject) => {
    _this.$get('/request/access/videoCheck', {}, _this.$GLOBAL.jsonConfig)
      .then((res) => {
        if (res.code === '00000') {
          let client = new OSS({
            // region: 'oss-cn-shanghai',
            region: 'oss-accelerate',// 加速域名
            accessKeyId: res.data.accessKeyId,
            accessKeySecret: res.data.accessKeySecret,
            stsToken: res.data.securityToken,
            bucket: 'jjlin'
          })
          resolve(client)
        } else {
          _this.$Mint.Toast(res.message);
        }
      })
  })
}

// 时间日期格式化
export const dateFormat = function (dateObj, format) {
  const date = {
    'M+': dateObj.getMonth() + 1,
    'd+': dateObj.getDate(),
    'h+': dateObj.getHours(),
    'm+': dateObj.getMinutes(),
    's+': dateObj.getSeconds(),
    'q+': Math.floor((dateObj.getMonth() + 3) / 3),
    'S+': dateObj.getMilliseconds()
  }
  if (/(y+)/i.test(format)) {
    format = format.replace(RegExp.$1, (dateObj.getFullYear() + '').substr(4 - RegExp.$1.length))
  }
  for (const k in date) {
    if (new RegExp('(' + k + ')').test(format)) {
      format = format.replace(RegExp.$1, RegExp.$1.length === 1
        ? date[k] : ('00' + date[k]).substr(('' + date[k]).length))
    }
  }
  return format
}

//生成随机数
export const randomString = function (num) {
  let chars = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', 'a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z']
  let res = ''
  for (let i = 0; i < num; i++) {
    var id = Math.ceil(Math.random() * 35)
    res += chars[id]
  }
  return res
}

//上傳圖片出錯
export function errorImage() {
  Mint.Toast({ message: '上傳失敗！請重試' });
  // setTimeout(() => {
  //   this.$router.push('/login')
  // },500)
}

//上传图片数量超出限制
export function handleExceed(num) {
  Mint.Toast(`最多上傳${num}張圖片！`);
}

//上传图片之前的回调函数
export function beforePicUpload(type, volume, file) {
  const isJPG = (file.type === 'image/jpeg') || (file.type === 'image/png');
  const isLt2M = file.size / 1024 / 1024 < Number(volume);
  console.log(isLt2M);

  if (!isJPG) {
    this.$message({
      message: '上傳圖片只能是jpg或者png格式!',
      type: 'error',
      center: true,
    })
  }
  ;
  if (!isLt2M) {
    this.$message({
      message: `上傳圖片大小不能超過${volume}MB!`,
      type: 'error',
      center: true,
    })
  }
  ;
  const isWidth = new Promise((resolve, reject) => {
    let _URL = window.URL || window.webkitURL;
    let img = new Image();
    img.onload = function () {
      if ((img.width < img.height) && type == 1) {
        Mint.Toast({ message: '請上傳橫屏圖片!' })
        reject();
      }
      if ((img.width > img.height) && type == 2) {
        Mint.Toast({ message: '請上傳豎屏圖片!' })
        reject();
      }
      // 图片大于2M或者宽度大于3000，进行图片压缩
      if (img.width > 3000 || file.size > 1024 * 1024 * 2) {
        imageConversion.compress(file, {
          quality: 0.3,
          width: 3000,
        }).then(res => {
          resolve(res);
        })
      } else {
        resolve(file);
      }
    }
    img.src = _URL.createObjectURL(file);
  })
  return isJPG && isLt2M && isWidth;
}

//cdn预热上传接口
export function cdnFun(url) {
  return new Promise((resolve, reject) => {

    this.$post(`/cdn/pushObjectCach?cdnObjectPath=${url}`, {}, this.$GLOBAL.jsonConfig)
      .then((res) => {
        if (res.code === '00000') {
          resolve(res)
        } else {
          // Mint.Toast(res.message);
          console.log(res.message)
        }
      })
  })
}

// cdn预热上传查询接口
export function checkCdnProgress(id) {
  return new Promise((resolve, reject) => {
    this.$get(`/cdn/describeRefreshTask?pushTaskId=${id}`, {}, this.$GLOBAL.jsonConfig)
      .then((res) => {
        if (res.code === '00000') {
          resolve(res)
        } else {
          Mint.Toast(res.message);
        }
      })
  })
}

export function convertVideo(name) {
  return new Promise((resolve, reject) => {
    this.$get(`/request/article/convertVideo?fileName=${name}`, {}, this.$GLOBAL.jsonConfig)
      .then((res) => {
        if (res.code === '00000') {
          resolve(res)
        } else {
          // Mint.Toast(res.message);
        }
      })
  })
}

// 全局提示
let messageInstance = null;
const resetMessage = (options) => {
  if (messageInstance) {
    messageInstance.close()
  }
  messageInstance = Message(options)
}
  ;
['error', 'success', 'info', 'warning'].forEach(type => {
  resetMessage[type] = options => {
    if (typeof options === 'string') {
      options = {
        message: options
      }
    }
    options.type = type;
    return resetMessage(options);
  }
});

export function propMessage(message, type, fn) {
  resetMessage({
    center: true,
    showClose: true,
    message: message,
    type: type,
    duration: 0,
    onClose: () => {
      if (typeof fn === "function") {
        fn()
      }
    }
  });
}

export function warnMessage(message,) {
  resetMessage({
    center: true,
    message: message,
    type: 'warning',
    duration: 2000,
  });
}
export function successMessage(message,) {
  resetMessage({
    center: true,
    message: message,
    type: 'success',
    duration: 2000,
  });
}
export function errorMessage(message,) {
  resetMessage({
    center: true,
    message: message,
    type: 'error',
    duration: 2000,
  });
}
export function formatTime(time) {
  let date = new Date(time)
  var year = date.getFullYear(); //得到年份
  var month = date.getMonth();//得到月份
  var day = date.getDate();//得到日期
  month = month + 1;
  if (month < 10) month = "0" + month;
  if (day < 10) day = "0" + day;
  return year + "-" + month + "-" + day;
}

// 和2013  做比较
export function compareTimeTo13(time) {
  let date1 = new Date('2013-1-1 00:00:00').getTime()
  let date2 = new Date(time).getTime()
  if (date1 > date2)
    return true
  return false

}



// WEBPACK FOOTER //
// ./src/utils/fn.js